import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock, BlockType, SettingType, TibboDataType, ValidationMessage, SettingState,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';


export default class Timer extends BaseFeature {
    constructor() {
        super();
        this.name = 'Timer';
        this.id = 'timer';
        this.priority = 50;
        this.singleInstance = false;
        this.linkedFeature = 'timers';

        const settings = [
            {
                id: 'TIMER_NAME',
                name: 'Timer Name',
                settingType: SettingType.NAME,
                dataType: TibboDataType.DWORD,
                required: true,
                default: 't',
            },
            {
                id: 'DESCRIPTION',
                name: 'Description',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getName(): string {
        const desc = this.getSettingValue('DESCRIPTION');
        return `${this.getSettingValue('TIMER_NAME')}${desc && ` (${desc})`}`;
    }

    initSettings(project: any, parentFeature?: any): void {
        super.initSettings(project, parentFeature, 'TIMER_NAME');
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }
}
